module.exports = __webpack_public_path__ + "img/service-06.89925d87.jpg";